<template>
  <div class="bg" v-show="show">
    <div class="wrapper">
      <img src="@assets/img/interview/close.svg" alt="close" class="close" @click="cancel()">
      <p class="msg">
        <span>
          {{config.msg}}
        </span>
      </p>
      <div class="btns">
        <p class="confirm green" @click="alpha()">{{config.alpha.title}}</p>
        <p class="cancel" @click="beta()">{{config.beta.title}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'confirm',
  data() {
    return {
      show: true,
      config: {
        msg: '',
        alpha: {
          title: '',
          handle: () => {}
        },
        beta: {
          title: '',
          handle: () => {}
        }
      },
      r: null
    }
  },
  methods: {
    open(c, r) {
      this.config = c
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
    },
    // confirm() {
    //   this.r(true)
    //   this.close()
    // },
    alpha() {
      this.config.alpha.handle()
      this.r(true)
      this.close()
    },
    beta() {
      this.config.beta.handle()
      this.r(true)
      this.close()
    },
    cancel() {
      this.r(false)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1008;
  }
  .wrapper {
    min-height: 240px;
    width: 400px;
    background-color: @bg;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    border-radius: 4px;
    z-index: 99998;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    .close {
      position: absolute;
      right: 28px;
      top: 18px;
      cursor: pointer;
    }
    .msg {
      width: 80%;
      padding: 10px 20px;
      line-height: 24px;
      color: @dark;
      font-size: 20px;
      min-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin:0 auto 40px;
      word-break: break-all;
    }
    .btns {
      height: 40px;
      align-items: center;
      display: flex;
      justify-content: center;
    }
    .confirm, .cancel {
      background-color: @bg;
      width: 120px;
      text-align: center;
      line-height: 40px;
      height: 40px;
      border-radius: 100px;
      border: 1px solid @green;
      color: @green;
      font-size: 14px;
      // box-shadow: 2px 1px 8px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
      &:hover {
        .btnHover;
      }
      &:active {
        .btnActive;
      }
    }
    .green {
      margin-right: 20px;
      color: #fff;
      background-color: @green;
    }
  }
</style>
